import { useNavigate } from 'react-router-dom';
import { Layout, Flex, Button } from 'antd';
import layoutStyles from 'components/Layout/Layout.module.scss';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import LazySvg from 'components/LazySvg';
import { PageTitle, PageDescription } from 'components/PagePartials';
import styles from './index.module.scss';

function AppErrorBoundary() {
  const navigate = useNavigate();

  const handleReturnBack = () => {
    navigate(-1);
  };

  return (
    <Layout className={`${layoutStyles.container} ${styles.layoutContainer}`}>
      <div className={layoutStyles.stickyContainer}>
        <Header />
      </div>
      <Flex vertical className={`${layoutStyles.contentWrapper} alignStretch`}>
        <Layout.Content
          className={`${layoutStyles.content} verticalFlex alignStretch`}
        >
          <Flex vertical className={layoutStyles.pageSectionWrapper}>
            <Flex
              vertical
              className='fullWidth fullHeight'
              align='center'
              justify='center'
            >
              <Flex
                vertical
                align='center'
                className={`${styles.errorBoundaryPageContainer} gap40`}
              >
                <LazySvg name='fail' className={styles.icon} />
                <Flex vertical align='center' className='gap16 alignStretch'>
                  <PageTitle section className={`${styles.title} textCenter`}>
                    Something went wrong on our end
                  </PageTitle>
                  <PageDescription section className='textCenter'>
                    We&apos;re working to resolve the problem. Please try again
                    later or contact customer support.
                  </PageDescription>
                </Flex>
                <Button
                  type='primary'
                  className={styles.btn}
                  onClick={handleReturnBack}
                >
                  Return to previous page
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Layout.Content>
        <Footer />
      </Flex>
    </Layout>
  );
}

export default AppErrorBoundary;
